module.exports = __webpack_public_path__ + "static/img/telegram-svgrepo-com.66afb6c2.svg";